/**
 * Created by iamso on 18.08.2021
 */

const GrowthFundLevelView = cc.Node.extend({
    ctor: function (data) {
        this._super();
        this.data = data;
        this.state = data.state;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(cleverapps.styles.GrowthFundLevelView);

        this.createContent();
    },

    createContent: function () {
        const styles = cleverapps.styles.GrowthFundLevelView;

        const insufficient = cleverapps.growthFund.findFirst(GrowthFund.STATE.INSUFFICIENT);
        this.reached = !insufficient || this.data.levelNo < insufficient.levelNo;

        const bg = this.bg = cleverapps.UI.createScale9Sprite(bundles.growth_fund.frames.lvl_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(this.getContentSize());
        this.addChild(bg);
        bg.setAlignment(this.width / 2, this.height / 2);

        if (bundles.growth_fund.frames.lvl_icon_bg) {
            const iconBg = cleverapps.UI.createScale9Sprite(bundles.growth_fund.frames.lvl_icon_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
            iconBg.setContentSize2(styles.iconBg);
            iconBg.setAlignment(styles.iconBg);
            bg.addChild(iconBg);

            bg.setCascadeOpacityEnabled(true);
            bg.setCascadeColorEnabled(true);
        }

        this.createReward();
        this.createTitle();
        this.createIcon();
        this.setState();

        if (!this.reached) {
            this.paintInsufficient();
        }
    },

    createReward: function () {
        const styles = cleverapps.styles.GrowthFundLevelView.rewards;

        const rewardsTitle = cleverapps.UI.generateOnlyText(Messages.get("RewardsListComponent.rewardTitle"), this.reached ? cleverapps.styles.FONTS.GROWTH_FUND_LEVEL_REWARD_REACHED : cleverapps.styles.FONTS.GROWTH_FUND_LEVEL_REWARD);
        const rewardsList = this.rewardsList = new RewardsListComponent({ hard: this.data.reward }, {
            font: this.reached ? cleverapps.styles.FONTS.GROWTH_FUND_LEVEL_VALUE_REACHED : cleverapps.styles.FONTS.GROWTH_FUND_LEVEL_VALUE,
            margin: styles.margin,
            noPrefix: true,
            textDirection: cleverapps.UI.HORIZONTAL,
            textMargin: styles.textMargin,
            icons: {
                hard: bundles.growth_fund.frames.rubies
            },
            small: true,
            event: cleverapps.EVENTS.EARN.PURCHASE
        });

        const rewards = new cleverapps.Layout([rewardsTitle, rewardsList], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin.x
        });
        this.addChild(rewards);
        rewards.setAlignment(styles);
    },

    createTitle: function () {
        const styles = cleverapps.styles.GrowthFundLevelView.title;
        let msg = "GrowthFundWindow.reach";
        let font = cleverapps.styles.FONTS.GROWTH_FUND_LEVEL_TITLE;

        if (this.reached) {
            msg = "GrowthFundWindow.reached";
            font = cleverapps.styles.FONTS.GROWTH_FUND_LEVEL_TITLE_REACHED;
        }

        const title = this.title = cleverapps.UI.generateOnlyText(Messages.get(msg, {
            level: this.data.levelNo + 1
        }), font);

        title.fitTo(styles.maxWidth);
        this.addChild(title);
        title.setAlignment(styles);
    },

    createIcon: function () {
        const styles = cleverapps.styles.GrowthFundLevelView.icon;

        const icon = new cc.Sprite(bundles.growth_fund.frames.rubies_heap);
        this.addChild(icon);
        icon.setAlignment(styles);
        this.icon = icon;
    },

    setState: function () {
        cleverapps.tooltipManager.remove(this);
        cleverapps.pointerManager.removeAll(this);
        let toolTip;

        switch (this.data.state) {
            case GrowthFund.STATE.INSUFFICIENT:
                toolTip = Messages.get("GrowthFundWindow.insufficient");
                this.createMark();
                break;
            case GrowthFund.STATE.WAITING:
                toolTip = Messages.get("GrowthFundWindow.getPrevious", {
                    level: cleverapps.growthFund.findFirst(GrowthFund.STATE.READY).levelNo + 1
                });
                this.createButton();
                break;
            case GrowthFund.STATE.READY:
                this.createButton();
                break;
            case GrowthFund.STATE.RECEIVED:
                this.createMark();
                break;
        }

        if (toolTip) {
            cleverapps.tooltipManager.create(this.button || this.mark, {
                text: toolTip
            });
        }
    },

    createButton: function () {
        const styles = cleverapps.styles.GrowthFundLevelView.button;
        this.button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text: Messages.get("Claim"),
            onClicked: this.onClick.bind(this)
        });
        this.addChild(this.button);
        this.button.setAlignment(styles);
    },

    onClick: function () {
        if (cleverapps.growthFund.isBought()) {
            if (this.data.state === GrowthFund.STATE.READY) {
                cleverapps.growthFund.takeReward(this.data.levelNo);

                if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation) {
                    this.rewardsList.receiveRewards();
                    this.rewardsList.receiveRewardsAnimation({
                        noFadeOut: true
                    });
                } else {
                    cleverapps.user.earnHard(cleverapps.EVENTS.EARN.GROWTH_FUND, this.data.reward);
                }
            }
        } else {
            cleverapps.focusManager.display({
                focus: "GrowthFundBuyWindow",
                stack: true,
                action: (f) => {
                    new GrowthFundBuyWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    },

    createMark: function () {
        const img = bundles.growth_fund.frames[this.data.state === GrowthFund.STATE.RECEIVED ? "checkmark" : "lock"];
        const mark = this.mark = new cc.Sprite(img);
        this.addChild(mark);
        mark.setAlignment(cleverapps.styles.GrowthFundLevelView.mark);
    },

    updateState: function () {
        if (this.state !== this.data.state || this.state === GrowthFund.STATE.WAITING) {
            this.state = this.data.state;
            this.removeAllChildren(true);
            this.createContent();
        }
    },

    paintInsufficient: function () {
        const paint = function (item) {
            item.setColor(new cc.Color(180, 180, 180, 255));
            item.setOpacity(140);
        };
        paint(this.bg);
        paint(this.icon);
        for (const key in this.rewardsList.targets) {
            paint(this.rewardsList.targets[key].icon);
        }
    }
});

cleverapps.styles.GrowthFundLevelView = {
    width: 960,
    height: 150,

    title: {
        maxWidth: 490,
        x: { align: "left", dx: 175 },
        y: { align: "center", dy: 25 }
    },

    icon: {
        width: 130,
        height: 130,
        x: { align: "left", dx: 25 },
        y: { align: "center", dy: 0 }
    },

    rewards: {
        margin: {
            x: 10
        },
        textMargin: 0,
        x: { align: "left", dx: 175 },
        y: { align: "center", dy: -25 }
    },

    mark: {
        x: { align: "right", dx: -134 },
        y: { align: "center" }
    },

    button: {
        width: 200,
        height: 80,
        x: { align: "right", dx: -68 },
        y: { align: "center" }
    }
};
